import { FC, ReactNode } from "react";

export const PairRowsFallback: FC = () => (
  <ul className="pair-rows">
    {[...Array(10)].map((_, i) => (
      <li key={`pair-row-skeleton-${i}`} className="pair-row">
        <div className="pair-row__favorite">
          <div className="skeleton round w-2 h-2" />
        </div>
        <div className="pair-row__body">
          <div className="lp pair-row__icons">
            <div className="icon-denom skeleton br-2" />
            <div className="icon-denom skeleton br-2" />
          </div>
          <div className="pair-row__pair">
            <div className="skeleton h-2 w-10 br-2" />
            <div className="skeleton h-1.5 w-6 br-2" />
          </div>
          <div className="pair-row__values">
            <div className="skeleton h-2 w-8 br-2" />
            <div className="skeleton h-1.5 w-5 br-2" />
          </div>
        </div>
      </li>
    ))}
  </ul>
);

export const PairRows: FC<{ children: ReactNode }> = ({ children }) => (
  <ul className="pair-rows">{children}</ul>
);
